"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromResize = void 0;

var _rxjs = require("rxjs");

var fromResize = function fromResize(element) {
  var ResizeObserver = window.ResizeObserver; // eslint-disable-line @typescript-eslint/no-explicit-any

  if (typeof ResizeObserver === 'undefined') {
    return (0, _rxjs.fromEvent)(window, 'resize');
  }

  var observer;
  return (0, _rxjs.fromEventPattern)(function (handler) {
    observer = new ResizeObserver(handler);
    observer.observe(element);
  }, function (_handler) {
    observer.unobserve(element);
  });
};

exports.fromResize = fromResize;